import React from 'react';
import { Button, ButtonProps } from 'antd';
import './IconButton.css';

/**
 * IconButton
 * A perfectly circular icon-only button (32×32) used for header/sidebar actions
 * like hamburger menu, close, back, and more.
 */
export default function IconButton({ className, ...props }: ButtonProps) {
    return (
        <Button
            type="text"
            {...props}
            className={`icon-button ${className || ''}`}
        />
    );
}
